module.exports = __webpack_public_path__ + "img/9.d26f37b9.jpg";